import React from 'react';

import { SpotlightManager } from '@atlaskit/onboarding';

export function LiveDocSpotlightsTourManager({ children }: { children: React.ReactNode }) {
	return <SpotlightManager blanketIsTinted={false}>{children}</SpotlightManager>;
}
